<template>
    <div class="keyword-manager">
      <div class="form-group">
        <label>Keywords (max 5)</label>
        <div class="custom-keywords">
          <div v-for="(keyword, index) in keywords" :key="index" class="keyword-item">
            <input 
              v-model="keywords[index]" 
              class="input-field keyword-input"
              placeholder="Enter keyword"
              @input="updateKeywords"
            />
            <button @click="removeKeyword(index)" class="btn btn-sm btn-outline keyword-remove">×</button>
          </div>
          <button 
            v-if="keywords.length < 5" 
            @click="addKeyword" 
            class="btn btn-sm btn-secondary add-keyword"
          >
            Add Keyword
          </button>
        </div>
        <small class="help-text">Add up to 5 keywords to search for. These are the main keywords used for content search. You must add at least one keyword.</small>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'KeywordManager',
    props: {
      modelValue: {
        type: Array,
        default: () => []
      }
    },
    emits: ['update:modelValue'],
    data() {
      return {
        keywords: [...this.modelValue]
      }
    },
    watch: {
      modelValue: {
        handler(newVal) {
          this.keywords = [...newVal];
        },
        deep: true
      }
    },
    methods: {
      addKeyword() {
        if (this.keywords.length < 5) {
          this.keywords.push('');
          this.updateKeywords();
        }
      },
      removeKeyword(index) {
        this.keywords.splice(index, 1);
        this.updateKeywords();
      },
      updateKeywords() {
        this.$emit('update:modelValue', this.keywords);
      }
    }
  }
  </script>
  
  <style scoped>
  .custom-keywords {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .keyword-item {
    display: flex;
    align-items: center;
  }
  
  .keyword-input {
    width: 200px;
  }
  
  .keyword-remove {
    margin-left: 5px;
    padding: 2px 8px;
    font-size: 16px;
  }
  
  .add-keyword {
    margin-top: 5px;
  }
  </style>